module.exports = __webpack_public_path__ + "img/log_bq.3568e591.svg";